import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

function ForgotLinks(props) {
  const { logInLink } = props;

  return (
    <Container className="mt--5 pb-5">
      <Row className="justify-content-center">
        <Col lg="5" md="7">
          <Row className="mt-3">
            <Col xs="6">
              <button type="button" id="go-to-login"
                      className="btn btn-link text-light" onClick={logInLink}>
                <FormattedMessage id="app.forgot_password.go_to_login"/>
              </button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export { ForgotLinks };
